import cn from "classnames";
import { If } from "components";
import Skeleton from "react-loading-skeleton";

import { ProgressProps } from "./Progress.types";

import styles from "./Progress.module.scss";

const Progress = ({
  title,
  subTitle,
  amount,
  percentage,
  isLoading,
  transparentBarBackground
}: ProgressProps) => {
  const formattedPercentage = percentage ? Math.round(percentage) : 0;

  return (
    <div className={styles.progress}>
      <If condition={!!title}>
        <div className={styles.progress__title}>
          {title}
          <p>{amount}</p>
        </div>
      </If>
      <If condition={!!subTitle}>
        <div className={styles.progress__subtitle}>
          {subTitle}
          <p className={styles.progress__percentage}>{percentage}%</p>
        </div>
      </If>

      {isLoading ? (
        <Skeleton className={styles.progress__skeleton} count={1} />
      ) : (
        <div
          className={cn(styles.progress__bar, {
            [styles["progress__bar--transparent"]]: transparentBarBackground
          })}
        >
          <div
            className={styles["progress__bar--filled"]}
            style={{ width: `${formattedPercentage}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default Progress;
